import { render, staticRenderFns } from "./source-select.vue?vue&type=template&id=578971bb&scoped=true&"
import script from "./source-select.vue?vue&type=script&lang=ts&"
export * from "./source-select.vue?vue&type=script&lang=ts&"
import style0 from "./source-select.vue?vue&type=style&index=0&id=578971bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578971bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VPagination})
